import 'es6-promise/auto';
import Vue from 'vue';
import App from './App.vue';
// import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';

// Axios API
import api from './assets/js/api';
Vue.prototype.$api = api;

// Vue Event Bus
import eventBus from './assets/js/event-bus';
Vue.prototype.$eventBus = eventBus;

// Inputs Validation
Vue.prototype.$validate = {
    emailRegex: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, // Email Validator
    phoneNumberRegex: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
    passwordRegex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$/,
    rules: {
        required: (value) => !!value || 'Required.',
        requiredList: (value) => !!value.length > 0 || 'Required.',
        email: (value) => {
            return Vue.prototype.$validate.emailRegex.test(value) || 'Email is invalid.';
        },
        password: (value) => {
            return Vue.prototype.$validate.passwordRegex.test(value) || 'Password is invalid.';
        },
        mobileNumber: (value) => {
            return Vue.prototype.$validate.phoneNumberRegex.test(value) || 'Mobile number is invalid.';
        },
        nameRequired: (value, prop, byDate = false, date = 0, mobile = false) => {
            let temp = typeof value === 'number' || value === null ? value : value.split(' ').join();
            if (mobile) {
                if (temp === '') {
                    return `The ${prop} field is required`;
                } else if (temp.length > 0 && temp.length < 11) {
                    return `The ${prop} format is invalid`;
                } else if (temp.length > 11) {
                    return `The ${prop} format is invalid`;
                } else {
                    return '';
                }
            }
            let text = date === 0 ? 'activate' : 'deactivate';
            return temp ? '' : !byDate ? `The ${prop} field is required` : `The ${text} field is required when ${text} setting is ${prop.toUpperCase()}.`;
        }
    },
    numbersOnly($event, withPoint) {
        let keyCode = $event.keyCode ? $event.keyCode : $event.which;
        if ((keyCode < 48 || keyCode > 57) && !((keyCode == 190 || keyCode == 46) && withPoint)) {
            $event.preventDefault();
        }
    },
    minPoints($event, withPoint) {
        let val = $event.target.value;
        let keyCode = $event.keyCode ? $event.keyCode : $event.which;
        // Key Code Values: 190 = period, 46 = delete, 48 = 0
        if (((keyCode <= 48 && val == 0) || keyCode > 57) && !((keyCode == 190 || keyCode == 46) && withPoint)) {
            $event.preventDefault();
        }
    },
    lettersOnly($event) {
        let keyCode = $event.keyCode ? $event.keyCode : $event.which;
        if ((keyCode < 97 || keyCode > 122) && (keyCode < 65 || keyCode > 90) && keyCode != 32 && keyCode != 45) {
            $event.preventDefault();
        }
    }
};

// Vue Cookies
import VueCookies from 'vue-cookies-reactive';
Vue.use(VueCookies);
Vue.$cookies.config('7d', '', '', true, 'Strict');

// Vue Notification
import VueNotification from 'vue-notification';
Vue.use(VueNotification);

// Global Mixin
import globalMixin from '@/mixins/global';
Vue.mixin(globalMixin);

// Vue Moment
import VueMoment from 'vue-moment';
Vue.use(VueMoment);

// Global Components
import '@/plugins/global-components';

import VueRecaptcha from 'vue-recaptcha';
Vue.component('vue-recaptcha', VueRecaptcha);

import VueCompositionAPI from '@vue/composition-api';
Vue.use(VueCompositionAPI);

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App)
}).$mount('#app');
